$(document).ready(function () {
    setTimeout(() => {
        $('.js-mks-globeBanner').removeClass('is-hidden');
    }, 1 * 1000)

    $('.js-mks-globeBanner-btnClose').click(() => {
        $('.js-mks-globeBanner').addClass('is-hidden');
    })
});
